import React from "react";

export default function Cart() {
  return <h1>hello from cart page</h1>;
}
